import { collection, getCountFromServer } from 'firebase/firestore';
import { db } from '../config/firebase';

export const USER_REGISTRATION_LIMIT = 950;

export async function checkRegistrationAvailable() {
  try {
    const teamsCol = collection(db, 'teams');
    const snapshot = await getCountFromServer(teamsCol);
    const count = snapshot.data().count;
    console.log('Current user count:', count); // Debug log
    return count < USER_REGISTRATION_LIMIT;
  } catch (error) {
    console.error('Error checking user count:', error);
    return true; // Changed to true as default - allow registration if check fails
  }
} 